import clsx from "clsx";
import {
  ButtonHTMLAttributes,
  AnchorHTMLAttributes,
  FunctionComponent,
  ReactNode,
} from "react";

import { SELECTORS } from "@ui/config";

import * as styles from "./LinkButton.css";

type Props = {
  text: string;
  displayType?: keyof typeof styles.container;
  className?: string;
  containerClassName?: string;
  textClassName?: string;
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
  underlineIcon?: boolean;
} & ButtonHTMLAttributes<HTMLButtonElement> &
  AnchorHTMLAttributes<HTMLAnchorElement>;

const LinkButton: FunctionComponent<Props> = ({
  text,
  className,
  textClassName,
  containerClassName,
  iconLeft,
  iconRight,
  underlineIcon = true,
  style,
  ...props
}) => {
  const Component = "href" in props ? "a" : "button";
  return (
    <Component
      className={clsx(styles.container, containerClassName)}
      {...props}
    >
      <span
        className={clsx(
          SELECTORS.LinkButton,
          styles.innerContainer,
          underlineIcon && styles.underline,
          className,
        )}
        style={style}
      >
        {iconLeft && <span>{iconLeft}</span>}
        <span
          className={clsx(!underlineIcon && styles.underline, textClassName)}
        >
          {text}
        </span>
        {iconRight && <span>{iconRight}</span>}
      </span>
    </Component>
  );
};

export default LinkButton;
